import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

export default function SurvivalTable({ participants, t }) {
  if (!Array.isArray(participants) || participants.length === 0) return null;

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 700, width: 32 }} />
            <TableCell sx={{ fontWeight: 700 }}>{t('leaderboard.player')}</TableCell>
            <TableCell sx={{ fontWeight: 700 }} align="right">{t('groups.survival.lastScore')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {participants.map((p) => (
            <TableRow
              key={p.userId}
              sx={!p.alive ? { bgcolor: 'action.disabledBackground', opacity: 0.7 } : undefined}
            >
              <TableCell>
                {!p.alive && <HighlightOffIcon fontSize="small" color="error" />}
              </TableCell>
              <TableCell>
                <Typography color={p.alive ? 'text.primary' : 'text.secondary'}>{p.name}</Typography>
                {!p.alive && p.eliminatedOnDate && (
                  <Typography variant="caption" color="text.secondary" display="block">
                    {t('groups.survival.eliminatedOn', { date: new Date(p.eliminatedOnDate).toLocaleDateString() })}
                  </Typography>
                )}
              </TableCell>
              <TableCell align="right">
                <Typography fontWeight={p.alive ? 700 : 400} color={p.alive ? 'primary.main' : 'text.secondary'}>
                  {p.lastScore != null ? p.lastScore : '—'}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
